/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Embed_Files_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to embed files. Please try again." |
*
* @param {Spaces_Embed_Files_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_embed_files_error = /** @type {((inputs?: Spaces_Embed_Files_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Embed_Files_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Einbetten von Dateien. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Failed to embed files. Please try again.")
});